import { PublishToFacebookWizard } from './PublishToFacebookWizard';

const PublishToFacebookWizardAngular = PublishToFacebookWizard.angular;

export { PublishToFacebookWizardAngular };
